"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var colors_1 = require("../colors");

var themes_1 = require("../themes");

var Close = function Close(props) {
  var _a;

  return react_1.default.createElement("svg", __assign({}, props, {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: 'new 0 0 48 48'
    },
    xmlSpace: "preserve"
  }), react_1.default.createElement("g", null, react_1.default.createElement("path", {
    fill: (_a = colors_1.getColor(props), _a !== null && _a !== void 0 ? _a : themes_1.defaultTheme.colors.default.onColor),
    id: "i-250",
    className: "st0",
    d: "M0,44.1L20.1,24L0,3.9L3.9,0L24,20.1L44.1,0L48,3.9L27.9,24L48,44.1L44.1,48L24,27.9L3.9,48L0,44.1 z"
  })));
};

exports.default = Close;